import React from 'react'
import { Folder, ArrowRight } from 'react-feather'
import { useHistory } from 'react-router-dom'

import s from './ProjectSearchList.module.css'

interface Props {
  totalRecords: number
  pushElementToLocalStorage: (text: string) => void
  searchText: string
  records: Project[]
  closeDropdown: () => void
}

export const ProjectSearchList: React.FC<Props> = ({
  totalRecords,
  pushElementToLocalStorage,
  searchText,
  records,
  closeDropdown,
}) => {
  const history = useHistory()

  if (totalRecords === 0) return null

  return (
    <div className={s.projectSearchResults}>
      <div className={s.projectsResultHeader}>Projects ({totalRecords})</div>
      <div className={s.projectsResultMenu}>
        {records.slice(0, 3).map((eachProject: Project) => (
          <button
            className={s.eachProjectResult}
            key={eachProject.id}
            onClick={() => {
              closeDropdown()
              history.push(`/project/${eachProject.id}`)
              pushElementToLocalStorage(eachProject.project_title)
            }}
          >
            <Folder className={s.icon} size={15} />
            <span className={s.projectResultName}>
              {eachProject.project_title}
            </span>
          </button>
        ))}
      </div>
      {
        <button
          className={s.viewallResult}
          onClick={() => {
            closeDropdown()
            history.push(`/projects?search_title=${searchText}`)
          }}
          data-id="us_viewAllProjects"
        >
          <span>View all Projects&nbsp;</span>
          <ArrowRight size={14} />
        </button>
      }
    </div>
  )
}
